import { tracked } from '@glimmer/tracking';

import type { APIData } from 'webapp-types';

export default class CustomMetricSetupFormApiMetricBuilderHeaderOrQueryParameter {
	@tracked key: string;
	@tracked value: string;
	@tracked disabled = false;
	@tracked hidden = false;

	constructor(data: APIData.CustomQuery.APIMetricBuilder.BuilderHeaderOrQueryParameter) {
		this.key = data.key;
		this.value = data.value;
		this.disabled = !!data.disabled;
		this.hidden = !!data.hidden;
	}

	get output(): APIData.CustomQuery.APIMetricBuilder.SettingKeyValuePair {
		return {
			key: this.key,
			value: this.value,
		};
	}

	get isEmpty(): boolean {
		return !this.key && !this.value;
	}

	get isValid(): boolean {
		return !!this.key && !!this.value;
	}
}
